export const staleTime = {
  // LIVE = explicit zero for queries that copy results into local state via onSuccess.
  LIVE: 0,
  PAGED: 5 * 60 * 1000
}

export const sparepartKeys = {
  all: ['spareparts'],
  infinite: (filters) => ['spareparts', 'infinite', filters]
}
